import React from 'react'
import { SpecialOfferAuth } from './SpecialOfferAuth'
import { AdvantagesCards } from './AdvantagesCards'
import { PopularTokens } from './PopularTokens'
import { InviteCard } from './InviteCard'
import { DailyAirdrops } from './DailyAirdrops'
import { MinimalCost } from './MinimalCost'
import { Liquidity } from './Liquidity'
import { SecurityWays } from './SecurityWays'
import { TradeApp } from './TradeApp'

export const Main = () => {
  return (
    <>
        <div className="main">
            <SpecialOfferAuth/>
            <AdvantagesCards/>
            <PopularTokens/>
            <InviteCard/>
            <DailyAirdrops/>
            <MinimalCost/>
            <Liquidity/>
            <SecurityWays/>
            <TradeApp/>
        </div>
    </>
  )
}
